import styled from '@emotion/styled';
import { ChevronDownIcon } from '../../Icon';
import { ITheme } from '../../../themer';
import { Css } from '../../../utils';
import { rotate } from '../../../../styles/animation/rotate';

interface ISelectToggleIconProps {
	isOpen: boolean;
}

export const StyledSelectToggleIcon = styled.div<{ isOpen: boolean }, ITheme>`
	margin-left: ${Css.pxToRem(8)};
	display: flex;
	align-items: center;

	svg {
		${(props) => rotate(props.isOpen)}

		path {
			fill: ${(props) => props.theme.color.secondaryLight};
		}
	}
`;

export function SelectToggleIcon({ isOpen }: ISelectToggleIconProps) {
	return (
		<StyledSelectToggleIcon isOpen={isOpen}>
			<ChevronDownIcon aria-hidden="true" />
		</StyledSelectToggleIcon>
	);
}
